module.exports = {
  __depends__: [
    require(227)
  ],
  __init__: [ 'bpmnRules' ],
  bpmnRules: [ 'type', require(81) ]
};
